(function(){
  if (window.__luxBackInStockSelectable) return;
  window.__luxBackInStockSelectable = true;

  const cache = new Map(); // handle -> Promise(variants)

  function getHandleFromUrl(url){
    try{
      const u = new URL(url, window.location.origin);
      const parts = u.pathname.split('/').filter(Boolean);
      const idx = parts.indexOf('products');
      if (idx >= 0 && parts[idx+1]) return parts[idx+1];
      return parts[parts.length - 1] || null;
    }catch(e){
      return null;
    }
  }

  function fetchVariants(handle){
    if (!handle) return Promise.resolve([]);
    if (!cache.has(handle)){
      cache.set(handle,
        fetch(`/products/${handle}.js`, { credentials:'same-origin' })
          .then(r => r.ok ? r.json() : Promise.reject())
          .then(d => d.variants || [])
          .catch(() => [])
      );
    }
    return cache.get(handle);
  }

  function variantOpts(v){
    // product.js variants usually have option1/2/3; sometimes options[]
    if (Array.isArray(v.options) && v.options.length) return v.options;
    return [v.option1, v.option2, v.option3].filter(Boolean);
  }

  function matchPartial(variant, selected){
    const o = variantOpts(variant);
    for (let i=0;i<selected.length;i++){
      if (selected[i] != null && o[i] !== selected[i]) return false;
    }
    return true;
  }

  function matchExact(variant, selected){
    const o = variantOpts(variant);
    for (let i=0;i<selected.length;i++){
      if (o[i] !== selected[i]) return false;
    }
    return true;
  }

  function getSelected(vs, optCount){
    const selected = new Array(optCount).fill(null);
    const radios = vs.querySelectorAll('input.swatch-input[type="radio"][name^="option-"]');
    radios.forEach(inp => {
      if (!inp.checked) return;
      const pos = parseInt(inp.name.split('-')[1], 10) - 1;
      if (pos >= 0) selected[pos] = inp.value;
    });
    return selected;
  }

  function setVariantId(vs, variants, selected){
    if (selected.some(v => v == null)) return;

    const current = variants.find(v => matchExact(v, selected));
    if (!current) return;

    // trova il form via attributo form sugli input
    const any = vs.querySelector('input.swatch-input[form]');
    const formId = any && any.getAttribute('form');
    const form = formId ? document.getElementById(formId) : vs.closest('form');

    if (!form) return;

    const idInput = form.querySelector('input[name="id"]');
    if (idInput){
      idInput.value = current.id;
      idInput.dispatchEvent(new Event('input', { bubbles:true }));
      idInput.dispatchEvent(new Event('change', { bubbles:true }));
    }

    // ATC off se sold out (l’app back in stock di solito appare proprio qui)
    const addBtn = form.querySelector('button[name="add"], button[type="submit"]');
    if (addBtn) addBtn.disabled = !current.available;
  }

  function sync(vs, variants){
    // conta opzioni dal massimo "option-X" presente
    const names = Array.from(vs.querySelectorAll('input.swatch-input[name^="option-"]'))
      .map(i => parseInt(i.name.split('-')[1], 10))
      .filter(n => Number.isFinite(n));
    const optCount = names.length ? Math.max(...names) : 1;

    const selected = getSelected(vs, optCount);

    // raggruppa input per posizione
    for (let pos=0; pos<optCount; pos++){
      const group = vs.querySelectorAll(`input.swatch-input[name="option-${pos+1}"]`);
      group.forEach(inp => {
        const li = inp.closest('.swatches-list-item');
        if (!li) return;

        const test = selected.slice();
        test[pos] = inp.value;

        const exists = variants.some(v => matchPartial(v, test));
        const anyAvail = variants.some(v => matchPartial(v, test) && v.available);

        // ✅ esiste = cliccabile SEMPRE, anche se sold out
        // ❌ non esiste = disabilitata
        inp.disabled = !exists;

        li.classList.toggle('lux-unavailable', !exists);
        li.classList.toggle('lux-soldout', exists && !anyAvail);
      });
    }

    // imposta la variante anche se sold out (fondamentale per back in stock)
    setVariantId(vs, variants, selected);
  }

  function initOne(vs){
    if (vs.dataset.luxBisInit === '1') return;
    vs.dataset.luxBisInit = '1';

    const url = vs.getAttribute('data-url') || vs.dataset.url || window.location.pathname;
    const handle = getHandleFromUrl(url);

    fetchVariants(handle).then(variants => {
      if (!variants || !variants.length) return;

      let raf = 0;
      const schedule = () => {
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(() => sync(vs, variants));
      };

      // Run now + on change (after theme updates)
      schedule();
      vs.addEventListener('change', () => setTimeout(schedule, 0));

      // Se il tema ri-disabilita, lo riblocchiamo noi
      const obs = new MutationObserver(() => schedule());
      obs.observe(vs, { subtree:true, attributes:true, attributeFilter:['disabled','class'] });
    });
  }

  function initAll(){
    document.querySelectorAll('variant-selector.variant-selector-wrapper').forEach(initOne);
  }

  initAll();
  document.addEventListener('shopify:section:load', initAll);
})();
